import Vue from "vue";
import {store} from "./storage";
import {router} from "./router";
import MainHeader from "./modules/header/Header";
import HeaderMainPage from "./modules/header/HeaderMainPage";
import {AppNotify} from './utils/app-notify';
import {
    Checkbox,
    DatePicker,
    Dialog,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Input,
    Loading,
    Popover,
    Switch,
    Table,
    TableColumn,
    TabPane,
    Tabs,
    Pagination,
} from "element-ui";
import {DataLayer} from "./utils/data-layer";
import width from "./mixins/width";
import Welcome from "./modules/welcome/Welcome.vue";
import Archive from "./modules/archive/Archive.vue";

Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Checkbox);
Vue.use(Popover);
Vue.use(Loading.directive);
Vue.mixin(width);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Switch);
Vue.use(DatePicker);
Vue.use(Pagination);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$optionsLoading = {customClass: 'loading', spinner: 'loading'};

window.Vue = Vue;

window.axios = require('axios');
window.axios.interceptors.request.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});
window.axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if ((error.response.status === 403 && !window.laravel.user) || error.response.status === 401) {
        router.push({name: 'login'});
    }
    return Promise.reject(error);
});

window.Vue.use(AppNotify);
window.Vue.use(DataLayer);

new Vue({
    el: '#welcome',
    store,
    router,
    data: () => ({
        menu: false,
        windowWidth: window.innerWidth,
    }),
    components: {
        MainHeader, Welcome, HeaderMainPage, Archive,
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    }
});
